/**
 * Route tree owned by the monitoring module. The app router composes this
 * tree alongside other modules' trees in `app/router/routes.ts` — it never
 * defines monitoring's child routes itself.
 */
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import { rootRoute } from '../../app/router/rootRoute';
import { monitoringDashboardSchema } from './schemas/monitoringDashboard.schema';

const MonitoringDashboard = lazy(() =>
  import('./pages/MonitoringDashboard').then((module) => ({
    default: module.MonitoringDashboard,
  })),
);

const monitoringIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'monitoring',
  validateSearch: monitoringDashboardSchema,
  component: MonitoringDashboard,
});

export const monitoringRouteTree = monitoringIndexRoute;
